import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import parser from "html-react-parser";
import { Box, Flex, Spinner, Text, Center } from "@chakra-ui/react";

import { useApiClient } from "../../shared/hooks";
import { NoDataFound } from "../../shared/components";

interface IBlog{
  title:string,
  description:string,
  content:string,
  cover_image:string,
  author:string,
  country_id:string
  updated_at:string
  gs_country:{
      name:string
  }
}

function BlogDetailsPage() {
  const { id } = useParams();
  const apiClient = useApiClient();

  const [blogDescription, setBlogDescription] = useState<IBlog | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiClient.getBlogById(id!, "prod");

        if (!data?.status) {
          throw new Error(data?.message);
        }
        setBlogDescription(data?.data as any);
        console.log(blogDescription, "Statat");
        setIsLoading(false);
      } catch (error: any) {
        console.error("Error occurred during fetch blog description:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Center>
      <Box maxWidth={"800px"} width={"100vw"}>
        <Flex flexDirection="column" p={{ base: 3, md: 4, lg: 6 }}>
          {isLoading && (
            <Flex
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="90vh"
            >
              <Spinner height={70} width={70} color="orange.500" />
            </Flex>
          )}

          {blogDescription !== null ? (
            <>
              <Box
                marginLeft={{ base: 5, md: 2 }}
                marginBottom={{ base: 4, md: 6 }}
              >
                <Flex
                  flexDirection={{ base: "column", md: "column", lg: "column" }}
                  alignItems="flex-start"
                  justifyContent="center"
                >
                  <Text
                    fontWeight={"700"}
                    fontSize={{ base: "2em", md: "2.8em", lg: "3em" }}
                    color="#363B52"
                  >
                    {blogDescription?.title}
                  </Text>
                  <Text
                    marginTop={{ base: -3, md: -5 }}
                    fontWeight="normal"
                    fontSize={{ base: "1.1em", md: "1.3em", lg: "1.5em" }}
                    color="#878999"
                  >
                    {blogDescription?.updated_at &&
                      moment(
                        blogDescription?.updated_at,
                        "YYYY-MM-DDTHH:mmZ"
                      ).format("MMMM D, YYYY")}{" "}
                    {blogDescription?.gs_country && (
                      <>
                        &nbsp;|&nbsp;
                        {blogDescription?.gs_country?.name
                          .charAt(0)
                          .toUpperCase() +
                          blogDescription.gs_country.name.slice(1)}
                      </>
                    )}
                  </Text>
                </Flex>
              </Box>
              <Box
                marginLeft={{ base: 5, md: 2 }}
                marginRight={{ base: 5, md: 2 }}
                marginTop={{ base: 3, md: 5 }}
              >
                {parser(blogDescription?.content || "")}
              </Box>
            </>
          ) : (
            <>
              {!isLoading && (
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  width="100%"
                  height="50vh"
                >
                  <NoDataFound />
                </Flex>
              )}
            </>
          )}
        </Flex>
      </Box>
    </Center>
  );
}

export default BlogDetailsPage;
